import GET_ARTICLES from "../plugins/getArticles";
import FORM_VALIDATE from "../plugins/formValidate";

export default function SERVICE() {
  $(()=>{

    const id = location.search.replace(/^(.*)article=([\d])+(.*)?$/,'$2') || '1'
    const serviceTitle = (t1,t2) => `<span>${t1}</span><small>${t2}</small>`
    switch (id){
      case '1':{
        $('body').addClass('is--service-top')
        $('.mainImgInner>h2').append(`<p class="p-service-contTitle">
          ${serviceTitle('What we can do !','リビングサンアイだからできること')}
        </p>`)
        break
      }
      case '2':{
        $('body').addClass('is--service-curtain')
        $('.mainImgInner>h2').append(`<p class="p-service-contTitle">
          ${serviceTitle('ORDER CURTAIN','オーダーカーテン')}
        </p>`)
        FORM_VALIDATE()
        break
      }
      case '3':{
        $('body').addClass('is--service-carpet')
        $('.mainImgInner>h2').append(`<p class="p-service-contTitle">
          ${serviceTitle('Carpet & Rug','カーペット・ラグ')}
        </p>`)
        FORM_VALIDATE()
        break
      }
      case '4':{
        $('body').addClass('is--service-recover')
        $('.mainImgInner>h2').append(`<p class="p-service-contTitle">
          ${serviceTitle('Refitting sofa and chair','ソファー・椅子の張替え')}
        </p>`)
        FORM_VALIDATE()
        break
      }
    }

    if(window.load['service-01']){
      window.load['service-01'].done(() => {
        GET_ARTICLES('.p-block-staff',{
          makeItem(item,opt) {
            return $(`
              <a href="${item.href}" class="${opt.prefix}__article">
                <img src="${item.thumb}" alt="${item.desc}" width="300">
                <p class="${opt.prefix}__name is-${window.siteinfo.sextable[item.id]||'male'}"><span>${item.desc.split('|')[0].replace(/^\s|\s$/m,'').replace(/\s+?/,'<br>')}</span></p>
              </a>`)[0]
          }
        }).done(() => {
          $('.p-block-staff__list').slick({
            autoplay: true,
            fade: false,
            speed: 1500,
            centerMode: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            arrows: false,
            infinite: true,
            variableWidth: true,
            swipeToSlide:true,
            slidesToShow: 4,
            responsive: [{
              breakpoint: 768,
              settings: {
                slidesToShow: 3,
                centerMode: true
              }
            }]
          })
        })
        
        GET_ARTICLES('.p-block-gallery')
        
      })
    }
    if(window.load['service-02']){
      window.load['service-02'].done(() => {

        $('[data-plugin="sp-slick"]').slick({
          mobileFirst: true,
          autoplay: false,
          fade: false,
          speed: 300,
          centerMode: true,
          pauseOnHover: false,
          pauseOnFocus: false,
          arrows: false,
          infinite: true,
          variableWidth: true,
          swipeToSlide:true,
          slidesToShow: 2,
          responsive: [{
            breakpoint: 768,
            settings: 'unslick'
          }]
        })
      })
    }

  })
}